import {useEffect, useState} from "react";
import {
  AppBar, Avatar, Backdrop, BottomNavigation,
  BottomNavigationAction,
  Box, Button, CircularProgress,
  Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider,
  IconButton,
  Menu,
  MenuItem, Paper, Snackbar, TextField,
  Toolbar,
  Typography
} from "@mui/material";
import {
  AccountCircle,
  Add,
  AddShoppingCart,
  Clear,
  ClearAll,
  ListAltOutlined,
  MonetizationOn
} from "@mui/icons-material";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {Link, Redirect, Route, Switch, useHistory} from "react-router-dom";
import {ListToBuy} from "./ListToBuy";
import Monetization from "./Monetization";
import {useUserState} from "../UserContext";
import axios from "axios";
import {isPurchased} from "../osp_utils";

export default function Main() {

  const [navigation, setNavigation] = useState(0);
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null);
  const [requesting, setRequesting] = useState(false)
  const [cardManage, setCardManage] = useState({
    open : false,
    saveAvailable : false,
    cardList : [""],
    warn : false,
  })
  const [pwdManage, setPwdManage] = useState({
    open : false,
    pwd : "",
    pwdConfirm : "",
    error : false,
    errorMessage : '',
    confirmError : false,
    confirmErrorMessage : '',
  })
  const [snackbar, setSnackbar] = useState({
    open : false,
    message : '',
  })
  const [buyInfo, setBuyInfo] = useState(()=>{
    let total = localStorage.getItem('lastTodayBuyTotal')
    let purchased = localStorage.getItem('lastTodayBuyPurchase')
    // console.log('today buy info ' + total + ' ' + purchased)
    return {
      total : (Boolean(total) ? parseInt(total) : 0),
      purchased :  (Boolean(purchased) ? parseInt(purchased) : 0),
    }
  })

  const userState = useUserState()

  const onPassKeyPress = (e) => {
    if(e.key === 'Enter'){
      console.log('onPassKeyPress Enter ' ,e)
      changePassword()
    }
  }

  const changePassword = () => {
    console.log('changePassword')

    if(!Boolean(pwdManage.pwd)) {
      setPwdManage({
        ...pwdManage,
        error: true, errorMessage: "패스워드를 입력하세요",
        confirmError: false, confirmErrorMessage: ""
      })
      return;
    }else if(pwdManage.pwd.length < 6) {
      setPwdManage({
        ...pwdManage,
        error: true, errorMessage: "패스워드는 6자리 이상이어야 합니다.",
        confirmError: false, confirmErrorMessage: ""
      })
      return;
    }else if(!Boolean(pwdManage.pwdConfirm)){
      setPwdManage({
        ...pwdManage,
        error: false, errorMessage: "",
        confirmError: true, confirmErrorMessage: "패스워드를 입력하세요"
      })
      return;
    }else if(pwdManage.pwdConfirm !== pwdManage.pwd){
      setPwdManage({
        ...pwdManage,
        error: false, errorMessage: '',
        confirmError : true, confirmErrorMessage: "패스워드가 일치하지 않습니다."
      })
      return;
    }

    closePwdManage()
    setRequesting(true)

    axios.post(`${process.env.REACT_APP_API_HOST}/user/info/changepw`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        pwd: pwdManage.pwd
      }
    }).then((resp) => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        setSnackbar({
          open: true,
          message: "패스워드를 업데이트 했습니다."
        })
      }

      setRequesting(false)
    }).catch((e)=>{
      setRequesting(false)
      setSnackbar({
        open: true,
        message: "패스워드를 업데이트를 실패 했습니다."
      })
    })
  }



  const postCardInfo = () => {
    console.log('postCardInfo')
    closeCardManage()
    setRequesting(true)
    const value = cardManage.cardList != null ? cardManage.cardList.join('/') : ''
    axios.post(`${process.env.REACT_APP_API_HOST}/user/info/card`, {
      // headers: {
      //   'Content-type': 'application/x-www-form-urlencoded',
      // },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        card_list: value
      }
    }).then((resp) => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        userState.data.data.card_list = value

        setSnackbar({
          open: true,
          message: "카드정보를 업데이트 했습니다."
        })
      }

      setRequesting(false)
    }).catch((e)=>{
      setSnackbar({
        open: true,
        message: "카드정보 업데이트를 실패했습니다.."
      })
      setRequesting(false)

    })
  }

  const logout = () => {
    console.log('logout ')
    cookie.remove(RECEIVER_COOKIE_KEY)
    history.replace('/signin')
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeCardManage = () => {
    setCardManage({...cardManage, open : false, warn : false})
  }

  const closePwdManage = () => {
    setPwdManage({...pwdManage, open : false, warn : false})
  }

  const checkCardSaveAvailable = (cardManage) => {
    const prevState = cardManage.saveAvailable

    if(cardManage.cardList === null){
      if(prevState){
        cardManage.saveAvailable = false
        setCardManage({...cardManage})
      }
      return
    }
    for (let card of cardManage.cardList){
      console.log(card + ' ' + card.includes('/'))
      if(((!Boolean(card)) || card.includes('/'))){
        cardManage.saveAvailable = false
        setCardManage({...cardManage})
        return
      }
    }

    if(!prevState){
      cardManage.saveAvailable = true
      setCardManage({...cardManage})
    }
  }

  useEffect(()=>{
    console.log(userState)
    if(userState.data != null && userState.data.data != null && !Boolean(userState.data.data.card_list)){
      setCardManage({open : true, cardList: [], saveAvailable: false, warn : true})
    }
  },[])


  const getUserName = () => {
    if(userState.data != null && userState.data.data != null && Boolean(userState.data.data.user_name)){
      return userState.data.data.user_name
    }

    return ''
  }

  useEffect(()=>{

    // console.log('today buy clear')
    localStorage.removeItem(`lastTodayBuyTotal`)
    localStorage.removeItem(`lastTodayBuyPurchase`)

    return (()=>{
      // console.log('today buy save', buyInfo, cardManage)
      localStorage.setItem(`lastTodayBuyTotal`, buyInfo.total)
      localStorage.setItem(`lastTodayBuyPurchase`, buyInfo.purchased)
    })
  },[buyInfo])


  return (
    <Box sx={{
      // display : 'flex',
      height : '100%',
      // backgroundColor: (theme) => theme.palette.grey[100],
      // alignItems : 'stretch',
    }}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h7" component="div" sx={{ flexGrow: 1 }}>
            {/*{'폴슨구매알바 (' + getUserName() + (buyInfo.total > 0 ? `, 오늘구매 ${buyInfo.purchased}/${buyInfo.total})` : ')')}*/}
            {'폴슨구매알바 ' +(buyInfo.total > 0 ? `(오늘구매 ${buyInfo.purchased}/${buyInfo.total})` : '')}
          </Typography>
          {/*<Typography variant="h7" component="div" sx={{ flexGrow: 1 }}>*/}
          {/*  {}*/}
          {/*</Typography>*/}
            <div>
              <Link
                style={{textDecorationLine : 'none', color : 'inherit'}}
                to={{pathname: 'https://docs.google.com/spreadsheets/d/1ZbU5d1e7A8dPSmVMPeHZiBDz7oMuM2O5REtsMUNM2Yg/edit#gid=0'}}
                target={"_blank"}
              >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={()=>{}}
                  color="inherit"
                >
                  <ListAltOutlined/>
                </IconButton>
              </Link>

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <Box sx={{pl : 2, pr : 2, pb : 1.5, pt : 0.5, display : 'flex', alignItems : 'center'}}>
                  <Avatar sx={{width : 26, height : 26, }}/>
                  <Typography sx={{marginLeft : 1,}}>{getUserName()}</Typography>
                </Box>
                <Divider/>
                <MenuItem onClick={()=>{
                  setAnchorEl(null)
                  if(!Boolean(userState.data.data.card_list)){
                    setCardManage({open : true, cardList: [], saveAvailable: false, warn : false})
                  }else{
                    const cardlist = userState.data.data.card_list.split('/')
                    setCardManage({open : true, cardList: cardlist, saveAvailable: false, warn : false})
                  }

                }}>
                  카드관리
                </MenuItem>
                <MenuItem onClick={()=>{
                  setAnchorEl(null)
                  setPwdManage({
                    open : true,
                    pwd: '',
                    pwdConfirm: '',
                    error: false,
                    errorMessage: ''
                  })
                }}>
                  패스워드변경
                </MenuItem>
                <MenuItem onClick={logout}>{`로그아웃`}</MenuItem>
              </Menu>
            </div>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{
          // backgroundColor: (theme) => theme.palette.grey[100],
          // backgroundColor : 'red',
          // flex : 1,
          display : 'flex',
          flexDirection : 'column',
          width: '100%',
          height: '100%',
          // overscrollBehavior : 'never',
        }}
      >
        <Toolbar />
        <Container
          maxWidth="lg"
          sx={{ pt: 1, pb: 0, flex : 1, }}
        >

          <Switch>
            <Route path='/buy' exact component={()=>{
              console.log('redirect')
              return <Redirect to={"/buy/list"}/>
            }}/>
            <Route
              path='/buy/list'
              render={() => <ListToBuy
                onList={(list)=>{
                  // console.log('onList ' + list)
                  if(list != null){
                    let purchase_count = 0;
                    for(let buy of list){
                      if(isPurchased(buy)){
                        purchase_count ++;
                      }
                    }

                    setBuyInfo({
                      total:  list.length,
                      purchased: purchase_count,
                    })
                    console.log(`list to buy ${purchase_count}/${list.length}`)
                  }else{
                    setBuyInfo({
                      total:  0,
                      purchased: 0,
                    })
                  }
                }}
              />}
            />
            <Route path='/buy/monetization' component={Monetization}/>
            {/*<Route path='/buy/money' component={ListToBuy}/>*/}
          </Switch>
        </Container>
        <BottomNavigation sx={{backgroundColor : '#00000000'}}/>
      </Box>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
          value={history.location.pathname === '/buy/list' ? 0 : 1}
          onChange={(event, newValue) => {
            // console.log('nav ' + newValue)
            setNavigation(newValue);

            if(newValue === 0){
              history.push('/buy/list')
            }else{
              history.push('/buy/monetization')
            }
          }}
        >
          <BottomNavigationAction
            sx={{
              color: "lightgray",
            }}
            label="오늘구매" icon={<AddShoppingCart />} />
          <BottomNavigationAction
            sx={{
              color: "lightgray",
            }}
            label="정산" icon={<MonetizationOn />} />
        </BottomNavigation>
      </Paper>
      <Dialog
        open={cardManage.open}
        onClose={()=>closeCardManage()}
      >
        <DialogContent>
          {
            cardManage.warn ?
              <DialogTitle>
                등록된 카드 정보가 없습니다.
              </DialogTitle>
              :
              <div/>
          }

          <DialogContentText>
            카드정보를 수정하세요
          </DialogContentText>
          <DialogContentText>
            (카드이름에 "/"는 입력할 수 없습니다.)
          </DialogContentText>
          <Box
            noValidate
            component="form"
            sx={{
              mt: 2,
              display: 'flex',
              flexDirection: 'column',
              // m: 'auto',
              width: '100%',
            }}
          >
            <Box>
            <IconButton
              color={'info'}
              // sx={{width : 120}}
              // fullWidth={false}
              // startIcon={<Add/>}
              onClick={()=>{
                if(cardManage.cardList != null){
                  cardManage.cardList= ["", ...cardManage.cardList]
                }else{
                  cardManage.cardList= [""]
                }
                setCardManage({
                  ...cardManage,
                })
              }}
            >
              <Add/>
            </IconButton>
            </Box>

            {
              cardManage.cardList != null ?
                cardManage.cardList.map((card, index) =>
                  <Box key={index} sx={{pt : 1, pb : 0, display : 'flex', alignItems : 'center'}}>
                    <IconButton
                      color={'error'}
                      onClick={(event)=>{
                        cardManage.cardList = cardManage.cardList.filter((v, i)=> i !== index)
                        setCardManage({
                          ...cardManage,
                        })
                        checkCardSaveAvailable(cardManage)
                      }}
                    >
                      <Clear/>
                    </IconButton>
                    <TextField
                      key={index}
                      // margin={"dense"}
                      sx={{margin : 0, p : 0}}
                      hiddenLabel
                      defaultValue={card}
                      value={card}
                      onChange={(event)=>{
                        cardManage.cardList[index] = event.target.value
                        setCardManage({
                          ...cardManage,
                        })
                        checkCardSaveAvailable(cardManage)
                      }}
                      variant="outlined"
                    />

                  </Box>
                )
                :<div/>
            }
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            onClick={()=>closeCardManage()}
          >
            {
              cardManage.warn ?
                "나중에 등록"
                :
                "취소"
            }

          </Button>
          <Button
            disabled={!cardManage.saveAvailable}
            variant={"contained"}
            color={'success'}
            onClick={()=>postCardInfo()}
          >
            저장
          </Button>
        </DialogActions>

      </Dialog>
      <Dialog
        open={pwdManage.open}
        onClose={()=>closePwdManage()}
      >
        <DialogContent>
          <DialogContentText>
            패스워드 변경
          </DialogContentText>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              mt: 4,
              pb: 8
            }}
          >

            <TextField
              // margin={"dense"}
              onKeyPress={(e)=>onPassKeyPress(e)}
              label={'패스워드'}
              defaultValue={pwdManage.pwd}
              value={pwdManage.pwd}
              onChange={(event)=>{
                pwdManage.pwd = event.target.value
                if(pwdManage.error && Boolean(pwdManage.pwd)){
                  pwdManage.error = false
                  pwdManage.errorMessage = ''
                }
                setPwdManage({
                  ...pwdManage,
                })
              }}
              type={"password"}
              variant="outlined"
              error={pwdManage.error}
              helperText={pwdManage.errorMessage}
            />
            <TextField
              onKeyPress={(e)=>onPassKeyPress(e)}
              // margin={"dense"}
              sx={{mt : 4}}
              label={'패스워드확인'}
              defaultValue={pwdManage.pwdConfirm}
              value={pwdManage.pwdConfirm}
              onChange={(event)=>{
                pwdManage.pwdConfirm = event.target.value
                if(pwdManage.confirmError && Boolean(pwdManage.pwdConfirm)){
                  pwdManage.confirmError = false
                  pwdManage.confirmErrorMessage = ''
                }
                setPwdManage({
                  ...pwdManage,
                })
                // checkCardSaveAvailable(cardManage)
              }}
              type={"password"}
              variant="outlined"
              error={pwdManage.confirmError}
              helperText={pwdManage.confirmErrorMessage}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            onClick={()=>closePwdManage()}
          >
            취소
          </Button>
          <Button
            variant={"contained"}
            color={'success'}
            onClick={()=>changePassword()}
          >
            변경
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={requesting}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={()=>setSnackbar({open : false, message: ''})}
        message={snackbar.message}
      />
    </Box>
  )
}

